export default __webpack_public_path__ + "locales/sr-Cyrl-RS/InfoPanel.json?hash=7e1aaac0b6f156403be6bb15ee6488c7";